import { Link } from "gatsby";

import { PERSONAL_EMAIL_DOMAINS_BLACKLIST } from "./common";

// Phone number formatting and validation
const invalidPhoneCharactersRegex = /[^0-9()\- ]/g;
const phoneNumberToFormatRegex =
    /^\(?([0-9]{3})?\)?[ ]?([0-9]{3})?-?([0-9]{4})?$/;

const formatPhoneNumber = (
    match,
    firstThreeDigits,
    middleThreeDigits,
    lastFourDigits
) => {
    let formattedNumber = "";
    const exceptions = /^\([0-9]{3}\)?$/;

    // Treat exceptions so that the user is not prevented from entering or deleting certain characters
    if (exceptions.test(match) || (lastFourDigits && !middleThreeDigits)) {
        return match;
    }

    if (firstThreeDigits) {
        formattedNumber += `(${firstThreeDigits.replace(/[()]/g, "")})`;
    }
    if (middleThreeDigits) {
        formattedNumber += " " + middleThreeDigits;
    }
    if (lastFourDigits) {
        formattedNumber += "-" + lastFourDigits;
    }

    return formattedNumber || match;
};

export const getFormattedPhoneNumber = number => {
    if (invalidPhoneCharactersRegex.test(number)) {
        return number.replace(invalidPhoneCharactersRegex, "");
    }
    const formattedNumber = number.replace(
        phoneNumberToFormatRegex,
        formatPhoneNumber
    );

    return formattedNumber.slice(0, 14);
};

export const isValidPhoneNumber = phoneNumber =>
    phoneNumberToFormatRegex.test(phoneNumber) && phoneNumber.length === 14;

const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = email => email && emailRegex.test(email.trim());

const nameRegex = /^[a-zA-Z]{1}[-',. a-zA-Z]*$/;

export const isValidName = name => name && nameRegex.test(name.trim());

const zipRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;

export const isValidZipCode = zipCode =>
    zipCode && zipRegex.test(zipCode.trim());

export const getNavItemProps = ({
    id,
    htmlId,
    externalLink,
    page,
    openInNewTab,
}) => {
    const props = {
        id: htmlId,
        key: id,
    };

    if (externalLink) {
        props.as = "a";
        props.href = externalLink;

        if (openInNewTab) {
            props.target = "_blank";
            props.rel = "noreferrer";
        }
    } else if (page) {
        props.as = Link;
        //Ensure ending with /
        props.to = page.path.replace(/\/?$/, "/");
    }

    return props;
};

const extractEmailDomain = email => {
    const domain = email.split("@").pop();
    return domain;
};

export const isEmailDomainAllow = email => {
    if (!email) return false;

    const domain = extractEmailDomain(email);

    return !PERSONAL_EMAIL_DOMAINS_BLACKLIST?.includes(domain);
};

export const getCtaProps = (link, pdf) => {
    if (!pdf?.url && !link) return;

    if (link?.startsWith("/")) {
        return {
            as: Link,
            to: link,
        };
    }

    return {
        as: "a",
        href: pdf?.url || link,
        download: !!pdf,
        target: "_blank",
        rel: "noreferrer",
    };
};

